module.exports = __webpack_public_path__ + "static/media/Rubeus Hagrid 2.f0b9864a.jpg";